import { BoundedPointerDragHandleProps } from './hooks/useBoundedPointerDrag.hook';

export interface JustInTimeCallDragHandleProps
  extends BoundedPointerDragHandleProps {}

/**
 * Vertical drag handle shown on the left edge of a JIT call card.
 *
 * @param props - Pointer drag handlers and dragging state.
 * @returns Left-side grey pill handle for repositioning the card.
 */
export const JustInTimeCallDragHandle = ({
  onPointerDown,
  isDragging,
}: JustInTimeCallDragHandleProps) => {
  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Drag call notification"
      aria-grabbed={isDragging}
      className={
        isDragging
          ? 'jit-call-drag-handle-hit-area jit-call-drag-handle-hit-area--dragging'
          : 'jit-call-drag-handle-hit-area'
      }
      onPointerDown={onPointerDown}
    >
      <div className="jit-call-drag-handle-visual" aria-hidden />
    </div>
  );
};
